
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('selectize');
require('dropzone/dist/dropzone-min');

window.bootbox = require('bootbox');

import bsCustomFileInput from 'bs-custom-file-input';

$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

$(function () {
    $('[data-toggle="popover"]').popover({
        container: 'body',
        html: true,
        placement: 'auto',
        sanitize: false
    });
});

$(function () {
    bsCustomFileInput.init();
});
